import b64toBlob from "b64-to-blob"
import JSZip from "jszip"
import moment from "moment"

export interface File {
    folderName?: string
    fileName: string
    binaryData: string
}
export class DownloadHelpers {
    static invokeDownloadLink(binaryData: string, fileName: string) {
        const data = DownloadHelpers.getAudioBlob(binaryData)
        if (data) {
            this.createLinkAndClick(data, fileName)
        }
    }

    static createLinkAndClick(data: Blob, fileName: string) {
        let a = document.createElement("a")
        a.href = window.URL.createObjectURL(data)
        a.download = fileName
        document.body.appendChild(a)
        /**
         * This conditional is for integration testing that allows
         * Cypress to find the download link to validate against
         */
        if ((window as any).Cypress) {
            return
        }
        a.click()
        document.body.removeChild(a)
    }

    static async zipAndSave(files: File[]) {
        const zip = new JSZip()
        const zipFileName = `tts_files_${moment()
            .utc()
            .format("YYYYMMDDHHmm")}.zip`
        for (const file of files) {
            const name = file.folderName ? `${file.folderName}/${file.fileName}` : file.fileName
            zip.file(name, file.binaryData, { base64: true })
        }
        const zipFile = await zip.generateAsync({ type: "blob" })
        this.createLinkAndClick(zipFile, zipFileName)
    }

    static getAudioBlob(data: string | undefined) {
        if (!data) {
            return undefined
        }
        return b64toBlob(data)
    }
}
